import * as yup from 'yup';
import { phoneRegExp } from 'helpers/regex';

export const validations = yup.object().shape({
  fantasyName: yup
    .string()
    .required('O nome fantasia é obrigatório')
    .nullable()
});

export const contactValidations = yup.object().shape({
  name: yup
    .string()
    .required('O nome é obrigatório')
    .nullable(),
  email: yup
    .string()
    .email('O e-mail precisa ser válido')
    .required('O e-mail é obrigatório')
    .nullable(),
  phone: yup
    .string()
    .trim()
    .matches(phoneRegExp, 'O telefone precisa ser válido')
    .required('O telefone é obrigatório')
    .nullable()
});